import React from "react";
import { connect } from "react-redux";
import { getAplicacionesExternas, eliminarAplicacionExterna } from "../aplicacionExterna/AplicacionExternaService";
import "../../styles/Empresa.css";
import AplicacionExternaDialogContent from "../aplicacionExterna/AplicacionExterna";
import Navbar from "../home/Navbar";
import AplicacionExternaDatos from "./AplicacionExternaDatos";
import MensajeFlash from '../mensajeFlash/MensajeFlash';
import PantallaCarga from "../mensajeFlash/PantallaCarga";
import { Modal, Row, Col, Container, Button } from 'react-bootstrap'
import { esSesionAdmin } from "../usuario/Usuario";
import {obtenerListaEmpresas} from "../empresas/EmpresaService";
import delete_forever from '../../styles/icons/delete.svg';
import edit from '../../styles/icons/edit.svg';
import visibility from '../../styles/icons/visibility.svg';
import ExclamacionIcon from '../../styles/icons/exclamation-circle.svg'
import search from "../../styles/icons/search.svg";
import Spinner from "react-bootstrap/Spinner";

class aplicacionesExternas extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      dialogTitle: "Registrar nueva aplicacion externa",
      dialogType: "add",
      submitText: "Guardar",
      disabledInput: false,
      selectedAplicacionExterna: {
        aplicacion: "",
        descripcion: "",
        url: "",
        usuario: "",
        pwd: "",
        id: "",
        idEmpresa: ""
      },
      mostrarMensaje: false,
      mensaje: "",
      severity: "",
      dialogIsOpen: false,
      dialogIsOpenVerDatos: false,
      openPantallaCarga: false,
      listaEmpresas: null,
      listaEmpresaSelected: null,
      pageSize: 10,
      search: "",
      loading: true
    };
    this.tableRef = React.createRef();
  }

  componentDidMount() {
    if (esSesionAdmin()) {
      obtenerListaEmpresas().then((res) => {
        this.setState({
          listaEmpresas: res.datos,
          listaEmpresaSelected: res.datos[0].id
      })
      })
    }
  }


  handleDialog = (value) => {
    this.setState({
      dialogIsOpen: value
    });
  };
  handleDialogClose = (value, mensaje = "", severity) => {
    if (value === false) {
      this.fetchAplicacionesExternas(0, this.state.pageSize, "");  //Para actualizar la grilla
      if (mensaje !== "") {
        this.setState({
          mostrarMensaje: true,
          mensaje: mensaje,
          severity: severity
        });
      }
    }
    this.setState({
      dialogIsOpen: value
    });
  };
  handleNewEmpresa = () => {
    this.handleDialog(true);
  };
  
  handleDialogVerDatos = (value) => {
    if (value === false) {
      this.fetchAplicacionesExternas(0, this.state.pageSize, "");  //Para actualizar la grilla
    }
    this.setState({
      dialogIsOpenVerDatos: value,
    });
  };
  handleClickOpen = () => {
    this.setState({
      open: true,
    });
  };

  handleClose = () => {
    this.setState({
      open: false,
    });
  };

  handleCloseMensajeFlash = () => {
    this.setState({
      mostrarMensaje: false,
    });
  };

  eliminarAplicacionExterna = () => {
    this.setState({ openPantallaCarga: true });
    this.handleClose();
    eliminarAplicacionExterna(this.state.selectedAplicacionExterna.id).then((respuesta) => {
      this.setState({ openPantallaCarga: false });
      if (respuesta.error) {
        this.setState({
          mostrarMensaje: true,
          mensaje: respuesta.mensaje,
          severity: "danger"
        })
        this.fetchAplicacionesExternas(0, this.state.pageSize, "");
      } else {
        this.setState({
          mostrarMensaje: true,
          mensaje: respuesta.mensaje,
          severity: "success"
        })
        this.fetchAplicacionesExternas(0, this.state.pageSize, "");
      }
    });
  }
  handlePageChange(newPage) {
    if (newPage >= 0 && newPage < this.state.totalPages) {
      this.setState({ page: newPage }, () => {
        this.fetchAplicacionesExternas(newPage, this.state.pageSize, "");
      });
    }
  }
  componentDidMount() {
    this.fetchAplicacionesExternas(0, this.state.pageSize, "");
  }

  handlePageChange = (newPage) => {
    if (newPage >= 0 && newPage < this.state.totalPages) {
      this.setState({ page: newPage }, () => {
        this.fetchAplicacionesExternas(this.state.page, this.state.pageSize, "");
      });
    }
  };

  handlePageSizeChange = (event) => {
    const newPageSize = parseInt(event.target.value, 10);
    this.setState({ pageSize: newPageSize, page: 0 }, () => {
      this.fetchAplicacionesExternas(this.state.page, this.state.pageSize, "");
    });
  };

  renderPageNumbers() {
    const { page, totalPages } = this.state;
    const maxVisiblePages = 5; // Máximo de páginas visibles

    let pages = [];

    if (totalPages <= maxVisiblePages) {
      // Mostrar todas las páginas si son pocas
      for (let i = 0; i < totalPages; i++) {
        pages.push(
          <li
            key={i}
            className={`page-item ${page === i ? "active" : ""}`}
            onClick={() => this.handlePageChange(i)}
          >
            <a className="page-link" type="Button">{i + 1}</a>
          </li>
        );
      }
    } else {
      // Mostrar primeras páginas, últimas y cercanas a la actual
      const startPage = Math.max(0, page - 2);
      const endPage = Math.min(totalPages - 1, page + 2);

      // Agregar primera página
      if (startPage > 0) {
        pages.push(
          <li
            key={0}
            className={`page-item ${page === 0 ? "active" : ""}`}
            onClick={() => this.handlePageChange(0)}
          >
            <a className="page-link" type="Button">1</a>
          </li>
        );
        if (startPage > 1) {
          pages.push(
            <li key="start-ellipsis" className="page-item disabled">
              <span className="page-link">...</span>
            </li>
          );
        }
      }

      // Agregar páginas visibles
      for (let i = startPage; i <= endPage; i++) {
        pages.push(
          <li
            key={i}
            className={`page-item ${page === i ? "active" : ""}`}
            onClick={() => this.handlePageChange(i)}
          >
            <a className="page-link" type="Button">{i + 1}</a>
          </li>
        );
      }

      // Agregar última página
      if (endPage < totalPages - 1) {
        if (endPage < totalPages - 2) {
          pages.push(
            <li key="end-ellipsis" className="page-item disabled">
              <span className="page-link">...</span>
            </li>
          );
        }
        pages.push(
          <li
            key={totalPages - 1}
            className={`page-item ${page === totalPages - 1 ? "active" : ""}`}
            onClick={() => this.handlePageChange(totalPages - 1)}
          >
            <a className="page-link" type="Button">{totalPages}</a>
          </li>
        );
      }
    }

    return pages;
  }

  fetchAplicacionesExternas(page, pageSize, search) {
    this.setState({ loading: true });
    this.props.getAplicacionesExternas(page, pageSize, search).then(() => {
      this.setState({
        aplicacionExterna: this.props.aplicacionExternaData.aplicacionExterna,
        page: this.props.aplicacionExternaData.page,
        totalCount: this.props.aplicacionExternaData.totalCount,
        totalPages: Math.ceil(
          this.props.aplicacionExternaData.totalCount / pageSize
        ),
        loading: false,
      });
    });
  }

  handleSearchChange = (e) => {
    const searchValue = e.target.value;
    this.setState({ search: searchValue }, () => {
      this.fetchAplicacionesExternas(0, this.state.pageSize, this.state.search);
    });
  };

  render() {
    return (
      <div>
        <div className="dashboardContent">
          <div className="container-fluid">
            <div>
              <PantallaCarga open={this.state.openPantallaCarga} />
              <Modal
                size="md"
                aria-labelledby="contained-modal-title-vcenter"
                centered
                show={this.state.open}
                onHide={this.handleClose}
                backdrop="static"
                keyboard="false"
              >
                <Container>
                  <Modal.Body>
                    <Row className="justify-content-center">
                      <Col className="text-center text-md-right">
                        <img src={ExclamacionIcon} alt='' style={{margin: '40px'}}></img>
                      </Col>
                    </Row>
                    <Row className="justify-content-center">
                      <Col className="text-center text-md-right">
                        <p><strong>Estas Seguro que desea eliminar la Aplicacion Externa?</strong></p>
                      </Col>
                    </Row>
                    <Row style={{ background: "#EDF2F9" }}>
                      <Col>
                        <p><strong>Aplicación:</strong> {this.state.selectedAplicacionExterna.aplicacion}</p>
                        <p><strong>Descripción: </strong>{this.state.selectedAplicacionExterna.descripcion}</p>
                      </Col>
                    </Row>
                  </Modal.Body>
                  <Modal.Footer>
                    <Button onClick={this.handleClose} variant="contained">Cancelar</Button>
                    <Button onClick={this.eliminarAplicacionExterna} color="primary" autoFocus>
                      Aceptar
                    </Button>
                  </Modal.Footer>
                </Container>
              </Modal>

              <Modal
                size="xl"
                aria-labelledby="contained-modal-title-vcenter"
                centered
                show={this.state.dialogIsOpenVerDatos}
                onHide={this.handleDialogVerDatos}
                keyboard="false">
                <AplicacionExternaDatos
                  aplicacionExterna={this.state.selectedAplicacionExterna}
                  handleClose={this.handleDialogVerDatos}
                  type={this.state.dialogType}
                  submitText={this.state.submitText}
                  disabledInput={this.state.disabledInput}
                  dialogTitle='Datos de aplicacion externa'
                />
              </Modal>

              <Modal
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered
                show={this.state.dialogIsOpen}
                onHide={this.handleDialogClose}
                keyboard="false">
                <AplicacionExternaDialogContent
                  aplicacionExterna={this.state.selectedAplicacionExterna}
                  handleClose={this.handleDialogClose}
                  type={this.state.dialogType}
                  submitText={this.state.submitText}
                  disabledInput={this.state.disabledInput}
                  dialogTitle={this.state.dialogTitle}
                  isAdmin={esSesionAdmin()}
                  listaEmpresas={this.state.listaEmpresas}
                  listaEmpresaSelected={this.state.selectedAplicacionExterna.idEmpresa}
                />

              </Modal>
              <MensajeFlash
                mensaje={this.state.mensaje}
                open={this.state.mostrarMensaje}
                severity={this.state.severity}
                handleClose={this.handleCloseMensajeFlash} />
              <div className="sectionHeader">
                <h1 className="pageTitle"> Aplicaciones Externas </h1>
                <div className="actions">
                  <Button className="btn btn-primary" onClick={this.handleNewEmpresa}> Nueva Aplicación Externa  </Button>
                </div>
              </div>
            </div>
            
            <Navbar
              menuActual={window.location.hash}
              seccionActual={ !esSesionAdmin() ? 'configuracion' : 'administracion'}
            />
          

          <div className="contentBuscador card">
              <form className="searchForm">
                <div className="input-group input-group-lg">
                  <span className="input-group-text border-0" id="basic-addon2">
                    <img src={search} />
                  </span>
                  <input
                    type="search"
                    className="form-control"
                    placeholder="Buscar.."
                    aria-label="Search"
                    aria-describedby="basic-addon2"
                    value={this.state.search}
                    onChange={this.handleSearchChange}
                  />
                </div>
              </form>
            </div>
            <div className="contentPage card" style={{ padding: "0px" }}>
            {this.state.loading ? (
                // Muestra el spinner mientras loading sea true
                <div className="d-flex justify-content-center p-5">
                  <Spinner animation="border" role="status">
                    <span className="visually-hidden">Cargando...</span>
                  </Spinner>
                </div>
              ) : ( <div>
              <div className="table-responsive">
                <table className="table table-striped table-hover">
                  <thead>
                    <tr>
                      <th scope="col">Aplicación</th>
                      <th scope="col">Descripción</th>
                      <th scope="col">URL</th>
                      <th scope="col">Api Key</th>
                      <th scope="col">Acciones</th>
                    </tr>
                  </thead>
                  <tbody>
                    {this.props.aplicacionExternaData.aplicacionExterna.map((aplicacionExterna, index) => (
                      <tr key={index}>
                        <th scope="row">{aplicacionExterna.aplicacion}</th>
                        <td>{aplicacionExterna.descripcion}</td>
                        <td>{aplicacionExterna.url}</td>
                        <td>{aplicacionExterna.apiKey}</td>
                        <td>
                          <div className="table-actions">
                          <a class="btn btn-secondary btn-md btn-floating" onClick={() => {
                      this.setState({
                        dialogTitle: "Editar Aplicación Externa",
                        selectedAplicacionExterna: aplicacionExterna,
                        dialogType: "edit",
                        submitText: "Editar",
                        disabledInput: false
                      }, () => {
                        this.handleDialog(true);
                      });
                    }}>
                          <img src={edit} />
                          </a>
                          <a class="btn btn-secondary btn-md btn-floating" onClick={() => {
                      this.setState({
                        dialogTitle: "Ver Aplicación Externa",
                        selectedAplicacionExterna: aplicacionExterna,
                        dialogType: "edit",
                        submitText: "Editar",
                        disabledInput: false
                      }, () => {
                        this.handleDialogVerDatos(true);
                      });
                    }}>
                          <img src={visibility} />
                          </a>
                          <a class="btn btn-secondary btn-md btn-floating" onClick={() => {
                      this.setState({
                        dialogTitle: "Ver Aplicación Externa",
                        selectedAplicacionExterna: aplicacionExterna,
                        dialogType: "edit",
                        submitText: "Editar",
                        disabledInput: false
                      }, () => {
                        this.handleClickOpen();
                      });
                    }}>
                          <img src={delete_forever} />
                          </a>
                          </div>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
              <div id="paginador">
                    <label>
                      Mostrar
                      <select
                        className="form-control custom-select"
                        id="maxRows"
                        name="state"
                        value={this.state.pageSize}
                        onChange={this.handlePageSizeChange}
                      >
                        <option value="5">5</option>
                        <option value="10">10</option>
                        <option value="20">20</option>
                        <option value="50">50</option>
                      </select>
                      resultados.
                    </label>
                    <ul className="pagination mb-0">
                      <li
                        className={`page-item ${
                          this.state.page === 0 ? "disabled" : ""
                        }`}
                        onClick={() =>
                          this.handlePageChange(this.state.page - 1)
                        }
                      >
                        <a className="page-link" type="Button">
                          <span className="material-icons">chevron_left</span>
                        </a>
                      </li>
                      {this.renderPageNumbers()}
                      <li
                        className={`page-item ${
                          this.state.page === this.state.totalPages - 1
                            ? "disabled"
                            : ""
                        }`}
                        onClick={() =>
                          this.handlePageChange(this.state.page + 1)
                        }
                      >
                        <a className="page-link" type="Button">
                          <span className="material-icons">chevron_right</span>
                        </a>
                      </li>
                    </ul>
                  </div>
              </div>)}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapDispatchToProps = (dispatch) => ({
  getAplicacionesExternas: (page, size, search) => dispatch(getAplicacionesExternas(page, size, search)),
});

const mapStateToProps = (state) => ({
  aplicacionExternaData: state.aplicacionExternaData,
});

export default connect(mapStateToProps, mapDispatchToProps)(aplicacionesExternas);
